import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

const canReviewUpcomingMeetingForParentQuery = gql`
  query CanReviewUpcomingMeetingForParent($sectionUid: ID!, $learnerUid: ID!) {
    canReviewUpcomingMeeting(sectionUid: $sectionUid, learnerUid: $learnerUid)
  }
`;

export default function useCanReviewUpcomingMeeting(
  sectionUid: string | null,
  learnerUid: string | null,
) {
  const { data, loading } = useQueryWithPreviousData(
    canReviewUpcomingMeetingForParentQuery,
    {
      variables: { sectionUid, learnerUid },
      skip: !sectionUid || !learnerUid,
    },
  );

  return !loading && data?.canReviewUpcomingMeeting;
}
